import type { KambiLiveData } from '@mobi/api-types/kambi'

/** Esports basketball does not provide a real match clock.
 * This helper extracts the current quarter by taking the last segment (e.g. "Q3") rather than rendering all quarters, to keep the live display concise and stable.
 * Kambi encodes period information in score.info as a string like: "Q1: 16-17 | Q2: 7-9 | Q3: 5-4"
 */
export const getCurrentQuarter = (score?: KambiLiveData['score']) => {
  if (!score?.info) return '-'

  const parts = score.info
    .split('|')
    .map(p => p.trim())
    .filter(Boolean)

  const last = parts[parts.length - 1]
  return last?.split(':')[0] ?? '-'
}
